// extracted by mini-css-extract-plugin
module.exports = {"h5button":"fC","h5Button":"fC","button":"fD","block":"fE","btnDefault":"fF","disable":"fG","btnPrimary":"fH"};